import { useState } from 'react';
import { useAuth } from '../../lib/auth';
import { CampoSenha, estiloCampo } from './campos';

// A porta da EQUIPE dentro do proprio aplicativo.
//
// ⚠️ **Existe em DOIS lugares de proposito, e o segundo nasceu de um relato.** A
// primeira versao so aparecia na tela de entrada — ou seja, so pra quem NAO estava
// logado. O Ruan, que ja usava o app com a conta de cliente dele pra testar, abriu e
// respondeu *"Nao vi onde acessar"*: pra achar a porta ele teria que sair primeiro.
// Recurso atras de um logout nao existe pra quem ja esta dentro. Hoje ela vive
// tambem no menu ☰, que e' onde o dedo ja esta.
//
// Peca unica pros dois lugares: dois formularios de login com a mesma
// responsabilidade divergiriam no primeiro ajuste.

const COBRE = '#b45309';

export function EntradaLoja({ aoVoltar }: { aoVoltar: () => void }) {
  const { login } = useAuth();
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  const pode = usuario.trim().length >= 2 && senha.length >= 1;

  async function submeter(e: React.FormEvent) {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      // Nao guarda nada por conta propria: o `useAuth` grava a credencial da equipe
      // e o `AppCliente` re-renderiza sozinho na visao da loja.
      await login(usuario.trim(), senha);
    } catch (err) {
      // ⚠️ O 403 aqui e' o device-trust, e a mensagem dele fala em "computador nao
      // autorizado" — texto que, num celular, manda a pessoa procurar um problema
      // que nao existe. Hoje so as contas com bypass entram sem certificado.
      const msg = (err as Error).message ?? '';
      setErro(/dispositivo|autorizado|computador/i.test(msg)
        ? 'Este login ainda nao pode entrar pelo celular. Fale com o Ruan.'
        : msg || 'Nao consegui entrar.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <form onSubmit={submeter} style={{ display: 'flex', flexDirection: 'column', gap: 14, padding: 16 }}>
      <p style={{ fontSize: 13.5, color: '#6b7280', lineHeight: 1.5, margin: 0 }}>
        Entre com o seu login do sistema para ver e responder todos os clientes.
      </p>
      <label style={{ display: 'block' }}>
        <span style={{ fontSize: 14, fontWeight: 600 }}>Login do sistema</span>
        <input
          className="no-upper"
          style={{ ...estiloCampo, marginTop: 6 }}
          value={usuario}
          onChange={(e) => setUsuario(e.target.value)}
          autoComplete="username"
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          placeholder="RUAN"
        />
      </label>

      <CampoSenha rotulo="Senha" valor={senha} aoMudar={setSenha} autoComplete="current-password" />

      {erro && (
        <div style={{ backgroundColor: '#fef2f2', color: '#b91c1c', padding: '10px 12px', borderRadius: 8, fontSize: 14 }}>
          {erro}
        </div>
      )}

      <button
        type="submit"
        disabled={!pode || enviando}
        style={{
          height: 52, borderRadius: 10, marginTop: 4, fontSize: 16, fontWeight: 700, color: '#fff',
          backgroundColor: pode && !enviando ? COBRE : '#d6d3d1',
        }}
      >
        {enviando ? 'Aguarde...' : 'Entrar como loja'}
      </button>

      <button
        type="button"
        onClick={aoVoltar}
        style={{ height: 46, fontSize: 15, color: '#6b7280' }}
      >
        Voltar
      </button>
    </form>
  );
}
